import React, { useEffect, useRef, useState } from "react";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
const EmployeePendingApproval = (params) => {
  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />

        <div className="inner-content row mx-0 finance-setting-chart chart-of-accounts">
          <div className="container px-0">
            <div className="row lbrSettingMs d-flex">
              <div className="col-md-12 modify">
                <div className="shadowclass mt-4 d-flex flex-wrap align-content-start">
                  <h4 className="event-alert w-100">Employee List</h4>

                  <div className="table-responsive">
                    <table className="checklist-table remove-space inventory_table my-0">
                      <thead>
                        <tr>
                          <th>Added By</th>
                          <th>Employee Name</th>
                          <th>ID # / Passport #</th>
                          <th>Function</th>
                          <th>Role Title</th>
                          <th>Contact Number #1</th>
                          <th className="action-td"> Action </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td colspan="7" className="text-center">
                            <strong>No record found.</strong>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default EmployeePendingApproval;
